import React from 'react';

type Props = {
  className?: string;
};

const ProductTestimonial: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div
        className={`bg-gray-900 opacity-100 z-0 relative `}
        style={{ marginLeft: '-50vw', marginRight: '-50vw' }}
      >
        <div
          className={`use_case_workflow z-0 relative ${className}`}
          style={{ marginLeft: '25vw', marginRight: '25vw' }}
          id={'order-pay'}
        >
          <div
            className={`bg-gray-800 z-0 relative `}
            style={{ background: 'rgba(17, 24, 39, 0.80)' }}
          >
            <div
              className={' z-20 relative md:py-20 lg:py-32 xl:py-48'}
              style={{ marginLeft: '25vw', marginRight: '25vw' }}
            >
              <div className={`py-12 overflow-hidden`}>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="text-center relative">
                    <blockquote className="mt-10">
                      <div className="max-w-3xl mx-auto text-center md:text-3xl text-lg leading-9 font-bold text-white">
                        <p>
                          &ldquo;With TableTab, it feels like providing a
                          private dining experience to each party.&rdquo;
                        </p>
                      </div>
                      <footer className="mt-8">
                        <div className="md:flex md:items-center md:justify-center">
                          <div className="md:flex-shrink-0"></div>
                          <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                            <div className="text-lg font-medium text-white">
                              Alan Buhtz, Head Server at Cassava
                            </div>
                          </div>
                        </div>
                      </footer>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductTestimonial;
